import { render, staticRenderFns } from "./Fenologia.vue?vue&type=template&id=4fcecf08"
import script from "./Fenologia.vue?vue&type=script&lang=js"
export * from "./Fenologia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports